export const getFirstTimeBuyer = () => localStorage.getItem('firstTimeBuyer');
